'use strict';

/**
 * Optional static narration on guided lesson steps (`step.audio`).
 * See docs/AUDIO_NARRATION_GUIDE.md for authoring.
 */

/**
 * @param {string} s
 */
function normalizeTextForCompare(s) {
  if (typeof s !== 'string') return '';
  return s.replace(/\s+/g, ' ').trim().toLowerCase();
}

/**
 * Narration metadata for UI when audio is enabled and src is present.
 * @param {object} step
 * @returns {{ src: string, transcript: string, durationSeconds?: number } | null}
 */
export function getStepNarrationAudio(step) {
  const raw = step?.audio;
  if (raw == null) return null;
  if (typeof raw !== 'object' || Array.isArray(raw)) return null;
  if (raw.enabled !== true) return null;
  const src = typeof raw.src === 'string' ? raw.src.trim() : '';
  if (!src) return null;
  const transcript = typeof raw.transcript === 'string' ? raw.transcript : '';
  const ds = Number(raw.durationSeconds);
  const out = {
    src,
    transcript,
  };
  if (Number.isFinite(ds) && ds > 0) {
    out.durationSeconds = ds;
  }
  return out;
}

/**
 * Body copy for the step: prefers transcript when it adds narration text without
 * duplicating the same words as `instruction`.
 * @param {object} step
 * @returns {string}
 */
export function getStepReadableInstruction(step) {
  const instruction = typeof step?.instruction === 'string' ? step.instruction : '';
  const raw = step?.audio;
  const transcript =
    raw && typeof raw === 'object' && !Array.isArray(raw) && typeof raw.transcript === 'string'
      ? raw.transcript
      : '';
  const t = transcript.trim();
  if (!t) return instruction;
  if (normalizeTextForCompare(instruction) === normalizeTextForCompare(t)) {
    return instruction;
  }
  return t;
}
